// Registers GTM at app level instead of in a component, so it is part of every
// SSR response, including error.vue (which Nuxt renders in place of app.vue and the layout).
export default defineNuxtPlugin(() => {
  const { gtmId, gtmDomain } = useRuntimeConfig().public

  if (!gtmId || !gtmDomain) {
    return
  }

  useHead({
    script: [{
      tagPosition: 'head',
      innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s);j.async=true;j.src=
'https://${gtmDomain}/'+i+'.js';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer',${JSON.stringify(gtmId)});`,
    }],
  })
})
